import React from 'react';
import { Link } from 'react-router-dom';

const legalLinks = [
  {
    label: 'Personvernerklæring',
    desc: 'GDPR & databehandling',
    href: '/privacy-policy-personvern',
    accent: '#3B6FD4',
    icon: '🔒'
  },
  {
    label: 'Vilkår & Betingelser',
    desc: 'Abonnement & bruk',
    href: '/terms-conditions-vilk-r-betingelser',
    accent: '#F97316',
    icon: '📋'
  },
  {
    label: 'FAQ',
    desc: 'Vanlige spørsmål',
    href: '/faq',
    accent: '#10B981',
    icon: '❓'
  }
];

const LegalResourcesSidebar = () => {
  return (
    <div
      style={{
        background: '#0D1520',
        border: '1px solid rgba(255,255,255,0.07)',
        padding: '24px',
        marginTop: '24px',
        transform: 'rotate(0.3deg)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '16px'
        }}
      >
        <div style={{ width: '3px', height: '20px', background: '#F97316' }} />
        <p
          style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: '0.65rem',
            fontWeight: 700,
            color: '#F97316',
            letterSpacing: '0.25em',
            textTransform: 'uppercase',
            margin: 0
          }}
        >
          Juridiske ressurser
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {legalLinks?.map((link, i) => (
          <Link
            key={i}
            to={link?.href}
            style={{ textDecoration: 'none' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '10px 12px',
                background: `${link?.accent}08`,
                border: `1px solid ${link?.accent}18`,
                borderLeft: `3px solid ${link?.accent}`,
                transition: 'all 150ms ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = `${link?.accent}14`;
                e.currentTarget.style.borderLeftColor = link?.accent;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = `${link?.accent}08`;
              }}
            >
              <span style={{ fontSize: '0.875rem' }}>{link?.icon}</span>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontFamily: 'Syne, sans-serif',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    color: '#EEF0F2',
                    letterSpacing: '-0.01em'
                  }}
                >
                  {link?.label}
                </div>
                <div
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.625rem',
                    color: link?.accent,
                    opacity: 0.8
                  }}
                >
                  {link?.desc}
                </div>
              </div>
              <span
                style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.625rem',
                  color: link?.accent,
                  opacity: 0.7
                }}
              >
                →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LegalResourcesSidebar;
